import FormField from '@/shared/ui/FormField';
import { OPTIONS } from '../model/demoLead';
import ChoiceGroup from './ChoiceGroup';

/** Step 3: problemi, moduli, urgenza e processo attuale. */
export default function NeedsStep({ lead, errors, onText, onChoose }) {
  const group = (name) => ({
    id: `demo-${name}`,
    options: OPTIONS[name],
    selected: lead[name],
    error: errors[name],
    onChoose: (value) => onChoose(name, value),
  });

  return (
    <>
      <ChoiceGroup
        {...group('mainChallenges')}
        label="Quali problemi pesano di più oggi?"
        hint="Selezione multipla"
      />
      <ChoiceGroup
        {...group('requestedModules')}
        label="Quali moduli vuoi vedere in demo?"
        hint="Cosa approfondire"
      />
      <ChoiceGroup
        {...group('urgency')}
        label="Urgenza del progetto"
        hint="Orizzonte decisionale"
      />
      <FormField
        id="demo-currentStack"
        name="currentStack"
        label="Processo o stack attuale"
        required
        rows={4}
        value={lead.currentStack}
        error={errors.currentStack}
        onChange={(value) => onText('currentStack', value)}
        placeholder="Es. Excel, GPS esterno, manutenzioni gestite via mail e fogli condivisi…"
        hint="Cosa usate oggi"
      />
    </>
  );
}
